import { ComponentProps, ComponentType, HTMLProps, PropsWithChildren, ReactNode } from 'react';
import { twc } from 'react-twc';
import { twMerge } from 'tailwind-merge';
import Box from '~/modules/Elements/AKUI/Primitives/Box';
import isE2E from '~/modules/utils/isE2E';

export const ButtonBase = twc(Box)((props) => {
  return [
    `
    flex-row!
    typography
    cursor-pointer
    justify-center
    border-0
    uppercase
    pointer-events-auto
    gap-4

    w-full
    rounded-[8px]

    px-[16px]
    sm:px-[22px]
    md:px-[26px]

    bg-[#242426]
    text-white
    shadow-[0_8px_18px_rgba(24,24,27,0.12)]

    transition
    duration-200
    will-change-transform

    text-[13px]
    sm:text-[14px]
    md:text-[15px]

    hover:bg-[#f45a0a]
    hover:shadow-none
    hover:-translate-y-[1px]

    focus-visible:bg-[#f45a0a]
    focus-visible:shadow-none
    focus-visible:-translate-y-[1px]
    focus-visible:outline-none
    `,
    !isE2E() && props['data-focused']
      ? 'bg-[#f45a0a] shadow-none ring-2 ring-[#ffb27a] ring-offset-1 ring-offset-transparent'
      : '',
    props['disabled']
      ? 'cursor-default text-gray-300! bg-gray-500 pointer-events-none animate-none! scale-100!'
      : 'active:bg-[#d94b00]',
    props['data-inactive'] ? 'line-through! decoration-white opacity-25' : 'no-underline!',
    props['data-read-only'] ? 'cursor-default! active:bg-[#242426]' : '',
  ];
});

interface Props extends PropsWithChildren {
  title?: ReactNode;
  inactive?: boolean;
  readOnly?: boolean;
  focused?: boolean;
}

const additionalProps = ({ inactive, readOnly, focused, ...props }: Props) => ({
  ...props,
  ...(focused ? { 'data-focused': true } : {}),
  ...(inactive ? { 'data-inactive': true } : {}),
  ...(readOnly ? { 'data-read-only': true, 'aria-readonly': true } : {}),
});

export const Button = ({ children, ...props }: Props & Omit<HTMLProps<HTMLButtonElement>, ''>) => (
  <ButtonBase {...additionalProps(props)} as="button">
    {children}
  </ButtonBase>
);

export const ButtonLink = ({ children, ...props }: Props & Omit<HTMLProps<HTMLAnchorElement>, ''>) => (
  <ButtonBase {...additionalProps(props)} as="a">
    {children}
  </ButtonBase>
);

Button.Icon = ({
  Icon,
  className,
  ...rest
}: {
  Icon: ComponentType<{ className?: ComponentProps<'svg'>['className'] }>;
  className?: ComponentProps<'svg'>['className'];
}) => <Icon {...rest} className={twMerge('h-8! w-8!', className)} />;
